//
//
//
//
//

export default {
  name: 'App'
};